import { render, staticRenderFns } from "./nms-management.vue?vue&type=template&id=53bcc848&"
import script from "./nms-management.vue?vue&type=script&lang=js&"
export * from "./nms-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports